module.exports = __webpack_public_path__ + "static/media/TJ-Date.abeddd45.svg";